import { httpCreate } from './http.js';
import conf from './config';
let APPID = 'wxd200d4b28ff0a828';

const http = httpCreate('/wx');

export const wxchat = {
	// wxConfig(BASE64_JSON,APPID) {
	//     // return http.get(`https://cdn.inmuu.com/wx/utils/miniprogram/${APPID}/${BASE64_JSON}.jpg`);
	//     return http.get(`${conf.cdnHost}/wx/utils/miniprogram/${APPID}/${BASE64_JSON}.jpg`);
	// },
	wxConfig(BASE64_JSON) {
		return `/wx/utils/miniprogram/${APPID}/${BASE64_JSON}.jpg`;
	},
	// 获取会拍的小程序码
	wxHuipaiConfig(BASE64_JSON) {
		return `/wx/utils/miniprogram/${APPID}/${BASE64_JSON}.jpg`;
	},
};
